import React from 'react';
import { PowerOutageScheduleErrorMessage } from '../plant-overview/PowerOutageScheduleErrorMessage';

type Props = {
  children: React.ReactNode;
  isError: boolean;
  errorMessage: string;
};

export function AccountManagementErrorWrapper({
  children,
  isError,
  errorMessage,
}: Props) {
  return (
    <div>
      {children}
      {isError && (
        <PowerOutageScheduleErrorMessage
          className="mt-[10px]"
          text={errorMessage}
        />
      )}
    </div>
  );
}
